<div>
  <mat-chip-set style="display: inline-block;">
    <mat-chip *ngIf="autorizacion$ | async as autorizacion; else sinAutorizacion" class="presencial-status" [disabled]="isDisabled">
      <mat-icon>how_to_reg</mat-icon>
      <label>{{autorizacion.fecha | date: 'dd LLL yyyy'}}</label>
    </mat-chip>
    <div *ngIf="edicion" >
      <button class="button-clean" (click)="eliminarAutorizacion()" *ngIf="autorizacion$ | async as autorizacion;">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-chip-set>
</div>
<!-- <button mat-icon-button (click)="eliminarAutorizacion()">
  <mat-icon class="icon">close</mat-icon>
</button> -->
<ng-template #sinAutorizacion>
  <div *ngIf="edicion" class="pseudo-chip">
    <a (click)="autorizarPresencial()">Autorizar presencial</a>
  </div>
</ng-template>
